import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useReviews } from '../../hooks/useReviews';
import { scrollToSection } from '../../utils/scroll';
import { RatingStars } from './RatingStars';
export const REVIEWS_SECTION_ID = 'reviews';

/**
 * X1-style rating banner: "★★★★★ 4.9 · 2,347 Reviews".
 * Renders only when published reviews exist in data/reviews.ts.
 */
export function ReviewSummaryBar({
  className = ''
}: {
  className?: string;
}) {
  const {
    lang
  } = useLanguage();
  const {
    summary
  } = useReviews();
  const es = lang === 'es';
  if (summary.count === 0) return null;
  return <button type="button" onClick={() => scrollToSection(REVIEWS_SECTION_ID)} className={`group flex w-full items-center gap-4 border border-white/25 bg-[#030A14] px-5 py-3.5 text-left transition-colors duration-150 hover:border-marine/60 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ice ${className}`} data-id="element-709" data-mp="en76akkivyqa">
      <RatingStars value={summary.average} size={20} decorative className="shrink-0" data-id="element-710" data-mp="s1ye2feq05t" />
      <p className="min-w-0 flex-1 font-display text-[15px] font-semibold uppercase tracking-[0.06em] text-ice" data-id="element-711" data-mp="3szs0lqgq8413">
        {summary.average.toFixed(1)} · {summary.count.toLocaleString(es ? 'es-US' : 'en-US')} {es ? 'reseñas' : 'reviews'}
      </p>
      <ChevronRightIcon className="h-5 w-5 shrink-0 text-titanium transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden data-id="element-712" data-mp="khvkq0zcrn2n" />
    </button>;
}